export class Splitter {
    splitter(values: string | number, _CALLBACKFN: (callback: Split) => void) {
        if (values) {
            String(values).split(' ').forEach((e: string) => {
                const split = e.split('@');
                return _CALLBACKFN({ value: split[0], media: this.setMedia(split[1]) });
            });
        }
    }
    setMedia(media: string | number): string {
        return media = media ? `@${media}` : '';
    }
}
interface Split {
    value: string;
    media: string;
}
